var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container_list_paos"},[(_vm.displaySpinner)?_c('v-layout',[_c('v-progress-circular',{staticClass:"spinner_doc",attrs:{"size":50,"indeterminate":true,"color":"primary"}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }